import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Table, Badge as BsBadge, Button, Tooltip, OverlayTrigger, Modal, Nav, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { DUYET_HOSO_TUYENSINH_API, DOTTUYENSINH_API, LOPDAOTAOLIENTUC_API, LOPDAOTAOTHUCHANH_API } from '@app/utils/apiUrl';
import { ACCOUNT_API } from '../../../../../utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    trangThaiHoSoDuTuyenValue,
    objectTrangThaiHoSoDuTuyen,
    objectShowNumber
} from '../../../../../utils/define';
import DuyetHoSoTuyenSinhDetailModal from './DuyetHoSoTuyenSinhDetailModal';
import ChamDiemDeCuongModalWrapper from '../../tuyenSinhTienSi/chiTietKetQuaNCS/ChamDiemDeCuongModalWrapper';

const DuyetHoSoTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [trangThaiFilter, setTrangThaiFilter] = useState('');
    const [namTuyenSinh, setNamTuyenSinh] = useState(new Date().getFullYear());
    const [dotTuyenSinhId, setDotTuyenSinhId] = useState('');
    const [cccdMap, setCccdMap] = useState({});
    const [activeTab, setActiveTab] = useState('0');
    
    // Modal states
    const [showDetail, setShowDetail] = useState(false);
    const [selectedHoSoId, setSelectedHoSoId] = useState(null);

    const [showChamDiemModal, setShowChamDiemModal] = useState(false);
    const [selectedHoSoIdChamDiem, setSelectedHoSoIdChamDiem] = useState(null);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionType, setActionType] = useState(null);
    const [ghiChuChinhSua, setGhiChuChinhSua] = useState('');
    const [submitting, setSubmitting] = useState(false);

    // Khởi tạo state từ URL params chỉ 1 lần khi component mount
    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        if (paramUrl.get('page') != null) {
            setPage(parseInt(paramUrl.get('page'), 10));
        }
        if (paramUrl.get('size') != null) {
            setPageSize(parseInt(paramUrl.get('size'), 10));
        }
        if (paramUrl.get('search') != null) {
            setSearch(paramUrl.get('search'));
        }
        if (paramUrl.get('nam') != null) {
            setNamTuyenSinh(parseInt(paramUrl.get('nam'), 10));
        }
        if (paramUrl.get('dot') != null && paramUrl.get('dot') !== '') {
            setDotTuyenSinhId(paramUrl.get('dot'));
        }
    }, []);

    const replaceHistory = (Page, Size, Search, Nam, Dot) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DUYET_HOSOTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search,
                nam: Nam,
                dot: Dot
            })
        );
    };

    const { data: listNamDataTS } = useQuery(
        ['listNamTuyenSinhDuyetHoSoTS'],
        () => Get(DOTTUYENSINH_API.GET_LIST_NAM, null, null),
        { keepPreviousData: true }
    );
    const { data: listNamDataLT } = useQuery(
        ['listNamTuyenSinhDuyetHoSoLT'],
        () => Get(LOPDAOTAOLIENTUC_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );
    const { data: listNamDataTH } = useQuery(
        ['listNamTuyenSinhDuyetHoSoTH'],
        () => Get(LOPDAOTAOTHUCHANH_API.GET_LIST_NAM_KHAI_GIANG, null, null),
        { keepPreviousData: true }
    );

    let rawListNam = [];
    if (activeTab === '0') {
        rawListNam = (Array.isArray(listNamDataTS) ? listNamDataTS : listNamDataTS?.$values) || [];
    } else if (activeTab === '1') {
        rawListNam = (Array.isArray(listNamDataLT) ? listNamDataLT : listNamDataLT?.$values) || [];
    } else if (activeTab === '2') {
        rawListNam = (Array.isArray(listNamDataTH) ? listNamDataTH : listNamDataTH?.$values) || [];
    }
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namTuyenSinh)) {
            const maxYear = Math.max(...rawListNam);
            setNamTuyenSinh(maxYear);
            replaceHistory(1, pageSize, search, maxYear, '');
        }
    }, [activeTab, listNamDataTS, listNamDataLT, listNamDataTH, namTuyenSinh]);

    const { data: listDotTuyenSinhDataTS } = useQuery(
        ['listDotTuyenSinhByNamTS', namTuyenSinh],
        () => Get(DOTTUYENSINH_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, NamTuyenSinh: namTuyenSinh }),
        { enabled: !!namTuyenSinh && activeTab === '0', keepPreviousData: true }
    );
    const { data: listDotTuyenSinhDataLT } = useQuery(
        ['listDotTuyenSinhByNamLT', namTuyenSinh],
        () => Get(LOPDAOTAOLIENTUC_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, NamKhaiGiang: namTuyenSinh }),
        { enabled: !!namTuyenSinh && activeTab === '1', keepPreviousData: true }
    );
    const { data: listDotTuyenSinhDataTH } = useQuery(
        ['listDotTuyenSinhByNamTH', namTuyenSinh],
        () => Get(LOPDAOTAOTHUCHANH_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, NamKhaiGiang: namTuyenSinh }),
        { enabled: !!namTuyenSinh && activeTab === '2', keepPreviousData: true }
    );

    let listDotTuyenSinh = [];
    if (activeTab === '0') {
        listDotTuyenSinh = listDotTuyenSinhDataTS?.data?.$values || listDotTuyenSinhDataTS?.data || [];
    } else if (activeTab === '1') {
        listDotTuyenSinh = listDotTuyenSinhDataLT?.data?.$values || listDotTuyenSinhDataLT?.data || [];
    } else if (activeTab === '2') {
        listDotTuyenSinh = listDotTuyenSinhDataTH?.data?.$values || listDotTuyenSinhDataTH?.data || [];
    }

    // Automatically set default "Tất cả" dotTuyenSinhId when year changes or active tab changes
    useEffect(() => {
        setDotTuyenSinhId('');
    }, [namTuyenSinh, activeTab]);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['duyetHoSoTuyenSinh', valueSearch, page, pageSize, trangThaiFilter, namTuyenSinh, dotTuyenSinhId, activeTab],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                TrangThaiHoSoDuTuyens: trangThaiFilter ? [Number(trangThaiFilter)] : [1, 2, 3, 4], // Lọc các hồ sơ đã gửi đi
                NamTuyenSinh: namTuyenSinh,
                LoaiTuyenSinh: Number(activeTab)
            };
            if (dotTuyenSinhId) {
                model.DotTuyenSinhId = dotTuyenSinhId;
            }
            replaceHistory(page, pageSize, valueSearch, namTuyenSinh, dotTuyenSinhId);
            return Get(DUYET_HOSO_TUYENSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, trangThaiFilter, namTuyenSinh, dotTuyenSinhId, activeTab]);

    const handleSelectTab = (k) => {
        setActiveTab(k);
        setPage(1);
    };

    useEffect(() => {
        const fetchCCCDs = async () => {
            if (!data?.data) return;
            const itemsToFetch = data?.data?.$values || data?.data || [];
            if (itemsToFetch.length === 0) return;
            
            const newCccdMap = { ...cccdMap };
            let changed = false;
            
            for (const app of itemsToFetch) {
                const accId = app.accountId || app.AccountId;
                if (accId && !newCccdMap[accId]) {
                    try {
                        const res = await Get(ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG, accId, null);
                        const fetchedUsername = res?.account?.username || res?.Account?.Username || res?.identityCardNumber || res?.IdentityCardNumber;
                        if (fetchedUsername) {
                            newCccdMap[accId] = fetchedUsername;
                            changed = true;
                        }
                    } catch (e) {
                        console.error('Lỗi khi lấy thông tin CCCD:', e);
                    }
                }
            }
            if (changed) {
                setCccdMap(newCccdMap);
            }
        };
        fetchCCCDs();
    }, [data]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, namTuyenSinh, dotTuyenSinhId);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, namTuyenSinh, dotTuyenSinhId);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, namTuyenSinh, dotTuyenSinhId);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const handleViewDetail = (app) => {
        setSelectedHoSoId(app.id || app.Id);
        setShowDetail(true);
    };

    const handleOpenChamDiem = (app) => {
        setSelectedHoSoIdChamDiem(app.id || app.Id);
        setShowChamDiemModal(true);
    };

    const handleOpenConfirm = (app, actionId) => {
        setSelectedHoSoId(app.id || app.Id);
        setActionType(actionId);
        setGhiChuChinhSua('');
        setShowConfirmModal(true);
    };

    const handleDuyet = async () => {
        if (!ghiChuChinhSua && (actionType === 2 || actionType === 4)) {
            toast.warning('Vui lòng nhập ghi chú / lý do để gửi tới người dùng!');
            return;
        }

        setSubmitting(true);
        try {
            const result = await Put(DUYET_HOSO_TUYENSINH_API.DUYET_HO_SO, selectedHoSoId, {
                Action: actionType,
                GhiChuChinhSua: ghiChuChinhSua
            });

            if (result && result.ok) {
                toast.success('Duyệt hồ sơ thành công!');
                setShowConfirmModal(false);
                setSelectedHoSoId(null);
                refetch();
            } else {
                toast.error(result?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
            }
        } catch (e) {
            toast.error('Lỗi kết nối máy chủ!');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid">
            <Tab.Container activeKey={activeTab} onSelect={handleSelectTab} id="tabs-duyet-ho-so-tuyen-sinh">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                                <Nav.Link eventKey="0" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="1" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="2" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Tab.Content>
                        <Tab.Pane eventKey={activeTab}>
                    <div className="d-flex mb-3">
                        <div className="d-flex align-items-center mr-3">
                            <span className="font-weight-bold mr-2">Năm:</span>
                            <Form.Control as="select" value={namTuyenSinh} onChange={(e) => { setNamTuyenSinh(Number(e.target.value)); setPage(1); }} style={{ width: '120px' }}>
                                {listNam.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div className="d-flex align-items-center mr-3">
                            <span className="font-weight-bold mr-2">{activeTab === '0' ? 'Đợt tuyển sinh:' : 'Lớp tuyển sinh:'}</span>
                            <Form.Control as="select" value={dotTuyenSinhId} onChange={(e) => { setDotTuyenSinhId(e.target.value); setPage(1); }} style={{ width: '250px' }}>
                                <option value="">{activeTab === '0' ? 'Tất cả đợt' : 'Tất cả lớp'}</option>
                                {listDotTuyenSinh.map((dot) => (
                                    <option key={dot.id || dot.Id} value={dot.id || dot.Id}>{dot.tenDot || dot.TenDot || dot.tenKhoaHoc || dot.TenKhoaHoc}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className="font-weight-bold mr-2">Trạng thái:</span>
                            <Form.Control
                                as="select"
                                value={trangThaiFilter}
                                onChange={(e) => { setTrangThaiFilter(e.target.value); setPage(1); }}
                                style={{ width: '200px' }}
                            >
                                <option value="">Tất cả (đã gửi)</option>
                                <option value={trangThaiHoSoDuTuyenValue.choDuyet}>Chờ duyệt</option>
                                <option value={trangThaiHoSoDuTuyenValue.duyet}>Đã duyệt</option>
                                <option value={trangThaiHoSoDuTuyenValue.tuChoi}>Từ chối</option>
                                <option value={trangThaiHoSoDuTuyenValue.canChinhSua}>Cần chỉnh sửa</option>
                            </Form.Control>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th style={activeTab === '0' ? { width: '50px' } : {}}>STT</th>
                                    {activeTab === '0' && <th style={{ width: '110px' }}>Số hồ sơ</th>}
                                    <th style={activeTab === '0' ? { width: '120px' } : {}}>Số CCCD</th>
                                    <th style={activeTab === '0' ? { width: '200px' } : {}}>Người nộp</th>
                                    <th>{activeTab === '0' ? 'Đợt tuyển sinh' : 'Lớp tuyển sinh'}</th>
                                    <th style={activeTab === '0' ? { width: '160px' } : {}}>Ngày nộp</th>
                                    <th className="text-center" style={activeTab === '0' ? { width: '130px' } : {}}>Trạng thái</th>
                                    <th className="text-center" style={{ width: activeTab === '0' ? '140px' : '120px' }}>Thao tác</th>
                                    {activeTab === '0' && <th className="text-center" style={{ width: '110px', whiteSpace: 'nowrap' }}>Chấm điểm</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={activeTab === '0' ? 9 : 7}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={activeTab === '0' ? 9 : 7}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={activeTab === '0' ? 9 : 7}>Không có hồ sơ nào.</td>
                                    </tr>
                                ) : (
                                    items.map((app, idx) => {
                                        const statusValue = app.trangThaiHoSoDuTuyen ?? app.TrangThaiHoSoDuTuyen;
                                        const statusLabel = getLabelFromEnum(statusValue, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue);
                                        const isChoDuyet = statusLabel === 'Chờ duyệt' || Number(statusValue) === 1;
                                        const cDate = app.createdDate || app.CreatedDate;
                                        const dateStr = cDate ? moment(cDate).format('DD/MM/YYYY HH:mm') : '';
                                        return (
                                            <tr key={app.id || idx}>
                                                <td>{(page - 1) * pageSize + idx + 1}</td>
                                                {activeTab === '0' && <td>{app.soHoSo || app.SoHoSo || 'Chưa cấp'}</td>}
                                                <td>{cccdMap[app.accountId || app.AccountId] || 'Đang tải...'}</td>
                                                <td>{app.hoTen || app.HoTen}</td>
                                                <td>{app.tenDotTuyenSinh || app.TenDotTuyenSinh}</td>
                                                <td>{dateStr}</td>
                                                <td className="text-center">
                                                    <BsBadge 
                                                        variant={
                                                            statusLabel === 'Duyệt' ? 'success' :
                                                            statusLabel === 'Từ chối' ? 'danger' :
                                                            statusLabel === 'Cần chỉnh sửa' ? 'warning' : 'info'
                                                        } 
                                                        className="px-2 py-1"
                                                    >
                                                        {statusLabel}
                                                    </BsBadge>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center">
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view-${idx}`}>Kiểm tra hồ sơ</Tooltip>}>
                                                            <Button variant="outline-primary" size="sm" className="mr-1" onClick={() => handleViewDetail(app)}>
                                                                <i className="fa fa-eye"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-approve-${idx}`}>Duyệt</Tooltip>}>
                                                            <Button variant={statusLabel === 'Duyệt' ? "success" : "outline-success"} size="sm" className="mr-1" onClick={() => handleOpenConfirm(app, 3)}>
                                                                <i className="fa fa-check"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-edit-${idx}`}>Yêu cầu chỉnh sửa</Tooltip>}>
                                                            <Button variant={statusLabel === 'Cần chỉnh sửa' ? "warning" : "outline-warning"} size="sm" className={statusLabel === 'Cần chỉnh sửa' ? "mr-1 text-white" : "mr-1"} onClick={() => handleOpenConfirm(app, 2)}>
                                                                <i className="fa fa-edit"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-reject-${idx}`}>Từ chối</Tooltip>}>
                                                            <Button variant={statusLabel === 'Từ chối' ? "danger" : "outline-danger"} size="sm" onClick={() => handleOpenConfirm(app, 4)}>
                                                                <i className="fa fa-times"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                {activeTab === '0' && (
                                                    <td className="text-center">
                                                        <Button variant="outline-info" size="sm" onClick={() => handleOpenChamDiem(app)}>
                                                            <i className="fa fa-star"></i>
                                                        </Button>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>
                            </Tab.Pane>
                        </Tab.Content>
                </Card.Body>
            </Card>
            </Tab.Container>

            {showDetail && (
                <DuyetHoSoTuyenSinhDetailModal 
                    show={showDetail} 
                    handleClose={() => {
                        setShowDetail(false);
                        setSelectedHoSoId(null);
                        refetch();
                    }} 
                    hoSoId={selectedHoSoId} 
                />
            )}

            {showChamDiemModal && (
                <ChamDiemDeCuongModalWrapper
                    show={showChamDiemModal}
                    handleClose={() => {
                        setShowChamDiemModal(false);
                        setSelectedHoSoIdChamDiem(null);
                    }}
                    hoSoId={selectedHoSoIdChamDiem}
                />
            )}

            {/* Confirm Modal for Từ chối / Cần chỉnh sửa */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} backdrop="static" style={{ zIndex: 10000 }} centered>
                <Modal.Header closeButton className={actionType === 4 ? 'bg-danger text-white' : actionType === 3 ? 'bg-success text-white' : 'bg-warning text-white'}>
                    <Modal.Title>{actionType === 4 ? 'Từ chối hồ sơ' : actionType === 3 ? 'Duyệt hồ sơ' : 'Yêu cầu chỉnh sửa hồ sơ'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {actionType === 3 && (
                        <p className="mb-3 text-success font-weight-bold">Bạn có chắc chắn muốn DUYỆT hồ sơ này?</p>
                    )}
                    <Form.Group>
                        <Form.Label className="font-weight-bold">
                            Ghi chú / Lý do {(actionType === 2 || actionType === 4) && <span className="text-danger">*</span>}
                        </Form.Label>
                        <Form.Control 
                            as="textarea" 
                            rows={4} 
                            placeholder={actionType === 3 ? "Nhập ghi chú (không bắt buộc)..." : "Nhập ghi chú hoặc lý do cho ứng viên..."}
                            value={ghiChuChinhSua} 
                            onChange={(e) => setGhiChuChinhSua(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Hủy</Button>
                    <Button 
                        variant={actionType === 4 ? 'danger' : actionType === 3 ? 'success' : 'warning'} 
                        className={(actionType === 2 || actionType === 3) ? 'text-white' : ''}
                        disabled={submitting} 
                        onClick={() => handleDuyet()}
                    >
                        {submitting ? 'Đang xử lý...' : 'Xác nhận'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DuyetHoSoTuyenSinh;
